import Component from "./components/UI/Component";
import Navigation from "./components/UI/Navigation/Navigation";
import GridCard from './components/Cards/GridCard';
import TextPhoto from "./components/TextPhoto/TextPhoto";
import Feature from "./components/Features/Feature";
import Accent from "./components/Accent/Accent";
import TextCards from "./components/TextCards/TextCards";
import TextBlock from "./components/TextBlock/TextBlock";
import TextList from "./components/TextList/TextList";
import PictureBlock from "./components/PictureBlock/PictureBlock";
import TextBordered from "./components/TextBordered/TextBordered";
import TextBackground from "./components/TextBackground/TextBackground";
import BagesList from "./components/Bages/BagesList";
import SmallCardsGrid from "./components/SmallCards/SmallCardsGrid";

import cards from './data/cards.json';
import textphoto from './data/textphoto.json';
import features from './data/features.json';
import textblock from './data/textblock.json';
import textlist from './data/textlist.json';
import textcards from './data/textcards.json';
import bages from './data/bages.json';
import smallcards from './data/smallcards.json';

function App() {
  return (
    <div className="App">
      <div className={'app__title'}>
          <h1>Brandly: Блоки Rich Content для карточки товара</h1>
      </div>
      <Navigation />
      <Component
          id={'target_1'}
          title={'1. Product cards grid'}
          text={'Элемент со значением <div class="info-grid"></div> нужен как контейнер для яэлементов карточки - он является основным и задаёт стили и разметку для остальных блоков.\n' +
          'Элемент со значеним <div class="info-grid__card">...</div> и со всем содержимым является разметкой карточки. В контейнере может быть сколько угодно карточек. Но, чтобы\n' +
          'они красиво отображались в десктопе и на телефоне рекомендуем размещать карточки в кол-ве кратное трём. Стилизация фона карточек в другин цвета происходить за счёт добавления классов info-grid__card-inner--primary и info-grid__card-inner--secondary'}
      >
        <GridCard cards={cards} />
      </Component>
      <Component
        id={'target_2'}
        title={'2. Text + Photo'}
        text={'Класс элемента "columns2--reverse" переволрачивает элементы в обратном порядке, что создаёт эффект различного вида вывода элементов.'}
      >
          <TextPhoto data={textphoto} />
      </Component>
      <Component
        id={'target_3'}
        title={'3. Features'}
        text={'Может использоваться как с заголовком, так и без заголовка. При использовании без заголовка, оборачивать все элементы в <div class="features"></div> необязательно.'}
      >
          <Feature
            title={'Почему iPhone'}
            data={features}
          />
      </Component>
      <Component
        id={'target_4'}
        title={'4. Accent'}
        text={'Акцентирование текста происходит за счёт его размещения внутри тега <span></span>. Кол-во тектовых блоков с иконкой может быть не обязательно 2, как в примере выше, а не ограниченное кол-во. '}
      >
          <Accent />
      </Component>
      <Component
        id={'target_5'}
        title={'5. TextCards'}
        text={'Для создания этого блока использовались блоки Text Block и Product cards grid. Все инструкции, которые указаны к выше упомянутым блокам можно применить и тут.'}
      >
          <TextCards data={textcards} />
      </Component>
      <Component
        id={'target_6'}
        title={'6. TextBlock'}
        text={'Текстовый блок состоит из 3-х элементов: заголовка, подзаголовка, текста-описания. Заголовок и подзаголовок можно менять местами, дляя этого нужно к классу class="text-block__title" добавить text-block__title--reverse, чтобы получилось class="text-block__title text-block__title--reverse". Также можно менять местами текст-описание и заголовок для этого нужно в класс class="columns2" добавить columns2--reverse, чтобы получилось class="columns2 columns2--reverse".'}
      >
          <TextBlock
              title={textblock.title}
              subtitle={textblock.subtitle}
              text={textblock.text}
          />
      </Component>
      <Component
        id={'target_7'}
        title={'7. TextList'}
      >
          <TextList data={textlist} />
      </Component>
      <Component
        id={'target_8'}
        title={'8. Picture'}
        text={'Данный код позваляет вставить любую картинку или серию картинок. Картинка будет вставляться на всю ширину контейнера. Скруглённые края картинки достигаются за счёт класса class="bordered". Если вставлять несколько картинок, то их нужно прописывать внутри блока с классом class="picture-block". Картинки будут выводится в столбик. Код самой картинки без блока обёртки ограничивается <picture class="bordered">...</picture>.'}
      >
        <PictureBlock />
      </Component>
      <Component
        id={'target_9'}
        title={'9. Text Bordered'}
      >
          <TextBordered>
              Качество товара, его безопасность для жизни, здоровья потребителей, окружающей среды, подтверждено в соответствии с требованиями законодательства. Подробная информация размещена на этикетке или упаковке товара, либо в технической документации к нему.
          </TextBordered>
      </Component>
      <Component
        id={'target_10'}
        title={'10. Text Background'}
        text={'В качестве заголовка можно использовать любой из вариаций, представленных на проекте. Для того, чтобы определить тип заголовка нужно в качестве класса для него указать h1-h2. В примере используется заголовок h2. Если мы хотим использовать особый цвет фона для текстового блока, то нам нужно к классу "text-background__bg" добавить через пробел название цвета. Допустимые названия цветов: primary - салатовый, secondary - розовый. '}
      >
          <TextBackground>
              <div className={'h2'}>Ингредиенты</div>{'\n'}
              <p>Сертифицированная базовая смесь органических фруктов для жевания: органическое яблоко (концентрат фруктового пюре и концентрат сока), органический персик (концентрат фруктового пюре), органическое волокно тапиоки, пектин (из яблок и апельсинов), органический вишневый ароматизатор, органический концентрат фиолетового морковного сока (для цвет), органический апельсин (кожура), органическая рисовая мука и органическое подсолнечное масло (для покрытия), сертифицированная органическая натуральная пищевая витаминная смесь: органическая эмблика (амла, филлантус эмблика) (плоды) экстракт, органическая сесбания крупноцветковая (листья), органический псидиум гуавава (плоды и листья гуавы), органический лимон (кожура), органический оцимум санктум (листья священного базилика), органический аннато (плоды и семена), органическая моринга масличная (листья моринги), органическая свекла (корень), органическая брокколи (стебель и цветок), органическая морковь (корень), органический шпинат (листья), органические помидоры (плоды), органическая ежевика (плоды), органические зеленый сладкий перец (плоды), органическая брюссельская капуста (листья), органический имбирь (корень), органическая черника (плоды), органический чеснок (луковица), органический зеленый лук (луковица), органическая малина (плоды), органическая петрушка (листья) , органическая цветная капуста (цветок и стебель), органическая краснокочанная капуста (лист), органическая спаржа (цветок и стебель), органический сельдерей (стебель), органический огурец (тыква), органическая капуста (лист).</p>
          </TextBackground>
      </Component>
      <Component
        id={'target_11'}
        title={'11. Bages'}
      >
          <BagesList bages={bages} />
      </Component>
      <Component
        id={'target_12'}
        title={'Small Cards'}
        text={'В данном блоке нужно обратить внимание на следующие правила. Есть строка с ингридиентами с классом "small-cards__row", кол-во элементов в этой строке задаётся классами "small-cards__col4" - 4 элемента в строке и "small-cards__col3" - элемента в строке. Окрашивание элементов происходит с помощью добавления к ним специального класса: "primary" - салатовый, "secondary" - розовый.'}
      >
          <SmallCardsGrid cards={smallcards} />
      </Component>
    </div>
  );
}

export default App;
